import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

export const getActionsCss = () => {
  return css`
    grid-area: actions;
    background-color: inherit;
    padding: var(--cds-spacing-200) var(--cds-spacing-300)
      var(--cds-spacing-300) var(--cds-spacing-300);

    ${breakpoints.down('xs')} {
      padding: var(--cds-spacing-150) var(--cds-spacing-200)
        var(--cds-spacing-200) var(--cds-spacing-200);
    }
  `;
};

export const getStickyActionsCss = () => {
  return css`
    position: sticky;
    bottom: 0;
    background-color: var(--cds-color-neutral-background-primary);
  `;
};
